<div class="uploader_container">
  <input
    type="file"
    [attr.multiple]="multiple"
    [attr.accept]="allowedFileMimeTypes"
    #defaultFileUploader
    (change)="onFileSelect($event.target.files)"
    class="uploader_input">

    @if (files.length) {
      <div
        class="uploader_content"
        #detailsEdit>
        @if (files.length === 1) {
          <span>{{files[0].name}}</span>
        }
        @if (files.length > 1) {
          <span>{{files.length}} attached files</span>
        }
        <span
          class="uploader_icon uploader_icon--indent"
          (click)="onUploaderClick()">
          <i class="fas fa-upload"></i>
        </span>
        <span
          class="uploader_icon"
          (click)="detailsShown = !detailsShown">
          <i class="fas fa-edit"></i>
        </span>
        @if (detailsShown) {
          <div class="uploader_popover">
            @for (file of files; track file; let i = $index) {
              <div class="uploader_list-item">
                <span >{{file.name}}</span>
                <span
                  (click)="onFileRemove($event, i)">
                  <i class="fas fa-times"></i>
                </span>
              </div>
            }
          </div>
        }
      </div>
    }

    @if (!files?.length) {
      <div
        class="uploader_placeholder"
        (click)="onUploaderClick()">
        <i class="fas fa-upload"></i>
        <span>{{ 'fileUploadPlaceholder' | translate }}</span>
      </div>
    }

  </div>